import { PageController } from '@client/components/_core/layout/PageController';
import { LlmStatsView } from '@client/components/admin/llm-stats/LlmStatsView';
import { createFileRoute } from '@tanstack/react-router';
import { BarChart3 } from 'lucide-react';

export const Route = createFileRoute('/admin-console/ai/request-analytics')({
    staticData: {
        permissions: ['admin_ai:read'],
        breadcrumb: {
            title: 'Request analytics',
        },
        ui: {
            icon: BarChart3,
            title: 'Request analytics',
            subtitle: 'View aggregated LLM request statistics and costs',
            widthVariant: 'fullWidth',
            menuDescription: 'Request-level analytics and cost tracking',
        },
    },
    component: RequestAnalyticsPage,
});

function RequestAnalyticsPage() {
    return (
        <PageController route={Route}>
            <LlmStatsView />
        </PageController>
    );
}
